<!--订单进度（横柱状，圆弧环状图）-->
<template>
  <div class="kee commonborder flex_row">
    <div id="kee_line" class="echarts"></div>
    <div id="kee_pie1" class="echarts"></div>
  </div>

</template>

<script>
import api from '@/apis/ProductionSystem'

let echarts = require('echarts/lib/echarts')
export default {
  data() {
    return {
      number: 100,
      lineData:[
        [],
        [],
        [],
      ]
    }
  },
  methods: {
    kee_line() {
      let kee_line = echarts.init(document.getElementById('kee_line'))
      kee_line.setOption({
        color: ['#00ccff', '#f4af1b'],
        tooltip: {
          trigger: 'axis',
          textStyle: { fontSize: this.$echartsFontSize },
          axisPointer: {
            type: 'shadow',
          },
        },
        legend: {
          data: ['订单量', '生产量'],
          right: 10,
          top: '2%',
          textStyle: {
            color: '#fff',
            fontSize: this.$echartsFontSize,
          },
          itemWidth: 15,
          itemHeight: 5,
        },
        grid: {
          left: '15px',
          right: '15px',
          top: '15px',
          bottom: '15px',
          containLabel: false,
        },
        xAxis: {
          type: 'value',
          show: false,
        },
        yAxis: {
          type: 'category',
          show: false,
          data: this.lineData[0],//['5#生产设备','4#生产设备','3#生产设备','2#生产设备','1#生产设备',],
        },
        series: [
          {
            name: '订单量',
            type: 'bar',
            barWidth: '20%',
            itemStyle: {
              normal: {
                label: { show: false },
                barBorderRadius: [0, 12, 12, 0],
              },
            },
            data:this.lineData[1],// [100, 200, 300, 400, 500],
          },
          {
            name: '生产量',
            type: 'bar',
            barWidth: '20%',
            barGap: '10%',
            itemStyle: {
              normal: {
                label: {
                  show: true,
                  position: [10, '-6px'],
                  formatter: '{b}',
                  lineHeight: '15',
                  color: '#3d4dae',
                   fontWeight:600,
                  fontSize: this.$echartsFontSize,
                  textShadowColor: '#fff', 
                  textShadowBlur: 2,
                  textShadowOffsetX: 1,
                  textShadowOffsetY: 1,
                },
                barBorderRadius: [0, 12, 12, 0],
              },
            },
            data: this.lineData[2],//[90, 190, 190, 390, 490],
          },
        ],
      })
    },
    kee_pie1() {
      let kee_pie1 = echarts.init(document.getElementById('kee_pie1'))
      kee_pie1.setOption({
        color: ['#ae74f3', '#3d4dae'],
        title: [
          {
            text: '生产总进度',
            x: 'center',
            top: '18%',
            textStyle: {
              color: '#ccd0f2',
              fontSize: this.$echartsFontSize + 2,
              fontWeight: '100',
            },
          },
          {
            text: this.number+'%',
            x: 'center',
            top: '55%',
            textStyle: {
              fontSize: this.$echartsFontSize + 12,
              color: '#fff',
              fontWeight: '600',
            },
          },
        ],
        polar: {
          radius: ['42%', '50%'],
          center: ['50%', '60%'],
        },
        angleAxis: {
          max: 100,
          show: false,
        },
        radiusAxis: {
          type: 'category',
        },
        series: [
          {
            type: 'bar',
            roundCap: true,
            barWidth: 60,
            showBackground: true,
            backgroundStyle: {
              color: 'rgba(255, 255, 255, .2)',
            },
            data: [this.number],
            coordinateSystem: 'polar',
          },
        ],
      })
    },
  },
  mounted() {

    api
      .schedule({
        params: {
          limit: 100,
          page: 1,
        },
      })
      .then((res) => {
        if (res.code === 10000) {
          if (res.data.list.length) {
            let dataArr = res.data.list
            for (const iterator of dataArr) {
              this.lineData[0].push(iterator.orderName)
              this.lineData[1].push(iterator.orderNum)
              this.lineData[2].push(iterator.proNum)
            }
            this.kee_line()
            let orderNumSum =  eval(this.lineData[1].join("+"));
            let proNumSum =  eval(this.lineData[2].join("+"));
            this.number = Math.round((proNumSum/orderNumSum)*100)
            this.kee_pie1()
          }
        } else {
          this.$message.error(res.message)
        }
      })


  },
}
</script>

<style lang="less" scoped>
.kee {
  #kee_line {
    height: 100%;
    width: 65%;
  }
  #kee_pie1 {
    height: 100%;
    width: 35%;
    position: relative;
  }
  #kee_pie1::before {
    content: '';
    position: absolute;
    top: 8%;
    left: 8%;
    width: 84%;
    height: 84%;
    background: rgba(3, 15, 97, 0.2);
    border: #555e86 dashed 1px;
    border-radius: 6px;
  }
}
</style>